import React from "react";
import { USER_ROLES } from "../../common/constants";
import { onCheckUserCanAccessTheModule } from "../../helpers/validationHelper";
import Button from "../Button";
import Icon from "../Icon";
import moment from "moment";

const convertToLocalTime = (datestring) => {
  let date = moment(datestring);
  if (date.isValid() && date.isAfter(moment())){
    return date.local().format("dddd MMM Do hh:mm A");
  }
  return "Booked";
};

const checkUser = () => {
  return onCheckUserCanAccessTheModule([
    USER_ROLES.HOME_OWNER,
    USER_ROLES.OCCUPANT,
  ]);
};

const Upcoming = () => (
  <div>
    <Button label="Upcoming" outlined disabled size="small" />
  </div>
)

const ScheduleButton = () => (
  <div>
    <Button label="Schedule" color="teal" size="small" />
  </div>
);

const RescheduleButton = ({ schedule }) => (
  <div>
    <Button label="Reschedule" color="teal" size="small" />
    {schedule && (
      <ScheduledText schedule={schedule} />
    )}
  </div>
);

const BeginButton = ({schedule}) => (
  <div>
    <Button
      label="begin"
      icon={<Icon glyph="walking" weight="light" size="small" />}
      color="teal"
      size="small"
    />
    {schedule && (
      <ScheduledText schedule={schedule} />
    )}
  </div>
);

const ScheduledText = ({schedule}) => {
  return (
    <div style={{ cursor: "default", marginTop: "8px" }}>
      {convertToLocalTime(schedule.scheduledAt)}
    </div>
  );
}

const ActivatedWalkThroughText = () => (
  <div style={{ fontSize: 10 }}>Activated Self-Guided Walk Through</div>
);

export const SimplifiedStatusButton = ({ data, handleActivateWalkthrough }) => {
  switch (data.status) {
    case "Activate":
      return checkUser()
        ? "Yet To Be Activated"
        : handleActivateWalkthrough(data, data.walkthroughType);

    case "Schedule":
      return checkUser() ? <ScheduleButton /> : "Awaiting Scheduling";

    case "Begin":
      if(checkUser()){
        return data.schedule === null ? (
          <Upcoming />
        ) : (
          <RescheduleButton schedule={data.schedule} />
        );
      }
      return (
        <div>
          <BeginButton schedule={data?.schedule} />
        </div>
      );

    case "Self-Guided Walk Through":
      return checkUser() ? <BeginButton schedule={data?.schedule} /> : <ActivatedWalkThroughText />;

    case "In Progress Home Only":
      return checkUser() ? "In Progress" : <ActivatedWalkThroughText />;

    default:
      return data.status;
  }
};

export const StatusButton = ({
  data,
  propertyManagerDetails,
  handleActivateWalkthrough,
}) => {
  if (checkUser())
    return homeOwnerStatusButton({ data, propertyManagerDetails });

  switch (data.status) {
    case "Begin":
      return <div>
          <BeginButton schedule={data?.schedule} />

        </div>;

    case "Activate":
      return handleActivateWalkthrough(data);
    
    case "Self-Guided Walk Through":
    case "In Progress Home Only":
      return <ActivatedWalkThroughText />;
    
    case "Schedule":
      return "Awaiting Scheduling";

    case "Guided Walk Through":
      return <BeginButton schedule={data?.schedule} />

    case "In Progress Home":
      return `In Progress(${data?.totalCheckedChecklist}/${data?.totalChecklist})`;
    case "Configure":
    case null:
      return "Configure";

    case "In Progress":
    case "Review":
    default:
      return data.status;
  }
};

const homeOwnerStatusButton = ({ data, propertyManagerDetails }) => {
  switch (data.status) {
    case "Begin":
      if(data.schedule === null) return <Upcoming />
      return <RescheduleButton schedule={data?.schedule} />;

    case "Schedule":
      return <ScheduleButton />;

    case "Guided Walk Through":
      return propertyManagerDetails && propertyManagerDetails.calendlyLink ? (
        "Schedule"
      ) : (
        <BeginButton schedule={data.schedule} />
      );

    case "Self-Guided Walk Through":
      return <BeginButton schedule={data.schedule}/>;

    case null:
    case "In Progress":
    case "Activate":
    case "Configure":
      return "Yet To Be Activated";

    case "Review":
    default:
      return data.status;
  }
};
